<template>
  <div class="animated fadeIn">
    <b-row class="mt-4">
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Zips Secured in Territory Master</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.SecureZipsNA"
              v-model="current_seminar.Tracker.DateSecureZips"
              :config="options"
              id="SecureZips"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="SecureZipsNA"
          v-model="current_seminar.Tracker.SecureZipsNA"
        />
        <span v-if="!current_seminar.Tracker.SecureZipsNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Added to Producer Program Tracker</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.AddedToPPTNA"
              v-model="current_seminar.Tracker.DateAddedToPPT"
              :config="options"
              id="AddedToPPT"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="AddedToPPTNA"
          v-model="current_seminar.Tracker.AddedToPPTNA"
        />
        <span v-if="!current_seminar.Tracker.AddedToPPTNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Request Counts from Vendor</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.CountRequestNA"
              v-model="current_seminar.Tracker.DateCountRequest"
              :config="options"
              id="CountRequest"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="CountRequestNA"
          v-model="current_seminar.Tracker.CountRequestNA"
        />
        <span v-if="!current_seminar.Tracker.CountRequestNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Counts Sent for Approval</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.CountApprovalNA"
              v-model="current_seminar.Tracker.DateCountApproval"
              :config="options"
              id="CountApproval"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="CountApprovalNA"
          v-model="current_seminar.Tracker.CountApprovalNA"
        />
        <span v-if="!current_seminar.Tracker.CountApprovalNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Confirm and Update TM</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.UpdateTMNA"
              v-model="current_seminar.Tracker.DateUpdateTM"
              :config="options"
              id="UpdateTM"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="UpdateTMNA"
          v-model="current_seminar.Tracker.UpdateTMNA"
        />
        <span v-if="!current_seminar.Tracker.UpdateTMNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Order Placed</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.PlacedOrderVendorNA"
              v-model="current_seminar.Tracker.DatePlacedOrderVendor"
              :config="options"
              id="PlacedOrderVendor"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="UpdateTMNA"
          v-model="current_seminar.Tracker.PlacedOrderVendorNA"
        />
        <span
          v-if="!current_seminar.Tracker.PlacedOrderVendorNA"
          class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Note in HQ (Order Placed)</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.PlacedNoteNA"
              v-model="current_seminar.Tracker.DatePlacedNote"
              :config="options"
              id="PlacedNote"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="UpdateTMNA"
          v-model="current_seminar.Tracker.PlacedNoteNA"
        />
        <span v-if="!current_seminar.Tracker.PlacedNoteNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Emailed Marketer (Order Placed)</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.EmailMarketerNA"
              v-model="current_seminar.Tracker.DateEmailMarketer"
              :config="options"
              id="EmailMarketer"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="UpdateTMNA"
          v-model="current_seminar.Tracker.EmailMarketerNA"
        />
        <span v-if="!current_seminar.Tracker.EmailMarketerNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Emailed Producer (Order Placed)</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.PlacedOrderProducerNA"
              v-model="current_seminar.Tracker.DatePlacedOrderProducer"
              :config="options"
              id="PlacedOrderProducer"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="UpdateTMNA"
          v-model="current_seminar.Tracker.PlacedOrderProducerNA"
        />
        <span
          v-if="!current_seminar.Tracker.PlacedOrderProducerNA"
          class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Added to Tuesday Sheet (New Producers Only)</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.AddedToTSNA"
              v-model="current_seminar.Tracker.DateAddedToTS"
              :config="options"
              id="AddedToTS"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="AddedToTSNA"
          v-model="current_seminar.Tracker.AddedToTSNA"
        />
        <span v-if="!current_seminar.Tracker.AddedToTSNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >New Producer % RSVP Tracker</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.NewProducerPercNA"
              v-model="current_seminar.Tracker.DateNewProducerPerc"
              :config="options"
              id="NewProducerPerc"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="NewProducerPercNA"
          v-model="current_seminar.Tracker.NewProducerPercNA"
        />
        <span
          v-if="!current_seminar.Tracker.NewProducerPercNA"
          class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Mail Landed</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.MailLandedNA"
              v-model="current_seminar.Tracker.DateMailLanded"
              :config="options"
              id="MailLanded"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="MailLandedNA"
          v-model="current_seminar.Tracker.MailLandedNA"
        />
        <span v-if="!current_seminar.Tracker.MailLandedNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Tracking Completed</b-input-group-text
              >
            </b-input-group-prepend>
            <datepicker
              :disabled="!current_seminar.Tracker.AddedToMapNA"
              v-model="current_seminar.Tracker.DateAddedToMap"
              :config="options"
              id="AddedToMap"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <c-switch
          width="100px"
          class="mx-3 pt-2"
          color="primary"
          variant="pill"
          label
          id="AddedToMapNA"
          v-model="current_seminar.Tracker.AddedToMapNA"
        />
        <span v-if="!current_seminar.Tracker.AddedToMapNA" class="text-muted"
          >Not Applicable</span
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text class="standardizedWidthExtraLong"
                >Tracking Notes</b-input-group-text
              >
            </b-input-group-prepend>
            <b-form-textarea
              v-model.lazy="current_seminar.Tracker.TrackingNotes"
              placeholder
              type="text"
              autocomplete="off"
              id="TrackingNotes"
              rows="3"
              @change.native="saveField"
            ></b-form-textarea>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import { mapState, mapActions } from "vuex";

export default {
  name: "SeminarTracker",
  props: {
    seminar_object: { type: Object }
  },
  components: { cSwitch, datepicker },
  data() {
    return {
      current_seminar: this.seminar_object,
      options: {
        format: "MM/DD/YYYY",
        useCurrent: true
        // ,
        // minDate: new Date()
        // ,
        // daysOfWeekDisabled: [0, 6]
      }
    };
  },
  computed: {
    ...mapState(["seminar"])
  },
  created() {
    //console.log(this.current_seminar.Tracker.SeminarID);
    if (this.current_seminar.Tracker.SeminarID === 0) {
      this.current_seminar.Tracker.SeminarID = this.current_seminar.SeminarID;
      this.$store
        .dispatch("seminar/AddTracking", this.current_seminar.Tracker)
        .then(response => {
          this.current_seminar.Tracker.TrackingID =
            response.data["AddTrackingResult"];
        });
    }
  },
  methods: {
    saveField: function(event) {
      var _operation = {
        SeminarID: this.current_seminar.SeminarID,
        TrackingID: this.current_seminar.Tracker.TrackingID,
        FieldToSet: event.target.id,
        ValueToSet: event.target.value
      };
      //console.log(_operation);
      this.$store.dispatch("seminar/SaveTracking", _operation).then();
    }
  },
  watch: {
    "current_seminar.Tracker.DateSecureZips": function() {
      var _event = {
        target: {
          id: "SecureZips",
          value: this.current_seminar.Tracker.DateSecureZips
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateCountRequest": function() {
      var _event = {
        target: {
          id: "CountRequest",
          value: this.current_seminar.Tracker.DateCountRequest
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateCountApproval": function() {
      var _event = {
        target: {
          id: "CountApproval",
          value: this.current_seminar.Tracker.DateCountApproval
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateUpdateTM": function() {
      var _event = {
        target: {
          id: "UpdateTM",
          value: this.current_seminar.Tracker.DateUpdateTM
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DatePlacedOrderVendor": function() {
      var _event = {
        target: {
          id: "PlacedOrderVendor",
          value: this.current_seminar.Tracker.DatePlacedOrderVendor
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DatePlacedNote": function() {
      var _event = {
        target: {
          id: "PlacedNote",
          value: this.current_seminar.Tracker.DatePlacedNote
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateEmailMarketer": function() {
      var _event = {
        target: {
          id: "EmailMarketer",
          value: this.current_seminar.Tracker.DateEmailMarketer
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateAddedToPPT": function() {
      var _event = {
        target: {
          id: "AddedToPPT",
          value: this.current_seminar.Tracker.DateAddedToPPT
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateAddedToMap": function() {
      var _event = {
        target: {
          id: "AddedToMap",
          value: this.current_seminar.Tracker.DateAddedToMap
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DatePlacedOrderProducer": function() {
      var _event = {
        target: {
          id: "PlacedOrderProducer",
          value: this.current_seminar.Tracker.DatePlacedOrderProducer
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateAddedToTS": function() {
      var _event = {
        target: {
          id: "AddedToTS",
          value: this.current_seminar.Tracker.DateAddedToTS
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateNewProducerPerc": function() {
      var _event = {
        target: {
          id: "NewProducerPerc",
          value: this.current_seminar.Tracker.DateNewProducerPerc
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.DateMailLanded": function() {
      var _event = {
        target: {
          id: "MailLanded",
          value: this.current_seminar.Tracker.DateMailLanded
        }
      };
      this.saveField(_event);
    },
    "current_seminar.Tracker.SecureZipsNA": function() {
      var _event = {
        target: {
          id: "SecureZipsNA",
          value: this.current_seminar.Tracker.SecureZipsNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.SecureZipsNA) {
        this.current_seminar.Tracker.DateSecureZips = null;
        var _event2 = {
          target: {
            id: "SecureZips",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.CountRequestNA": function() {
      var _event = {
        target: {
          id: "CountRequestNA",
          value: this.current_seminar.Tracker.CountRequestNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.CountRequestNA) {
        this.current_seminar.Tracker.DateCountRequest = null;
        var _event2 = {
          target: {
            id: "CountRequest",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.CountApprovalNA": function() {
      var _event = {
        target: {
          id: "CountApprovalNA",
          value: this.current_seminar.Tracker.CountApprovalNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.CountApprovalNA) {
        this.current_seminar.Tracker.DateCountApproval = null;
        var _event2 = {
          target: {
            id: "CountApproval",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.UpdateTMNA": function() {
      var _event = {
        target: {
          id: "UpdateTMNA",
          value: this.current_seminar.Tracker.UpdateTMNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.UpdateTMNA) {
        this.current_seminar.Tracker.DateUpdateTM = null;
        var _event2 = {
          target: {
            id: "UpdateTM",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.PlacedOrderVendorNA": function() {
      var _event = {
        target: {
          id: "PlacedOrderVendorNA",
          value: this.current_seminar.Tracker.PlacedOrderVendorNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.PlacedOrderVendorNA) {
        this.current_seminar.Tracker.DatePlacedOrderVendor = null;
        var _event2 = {
          target: {
            id: "PlacedOrderVendor",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.PlacedNoteNA": function() {
      var _event = {
        target: {
          id: "PlacedNoteNA",
          value: this.current_seminar.Tracker.PlacedNoteNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.PlacedNoteNA) {
        this.current_seminar.Tracker.DatePlacedNote = null;
        var _event2 = {
          target: {
            id: "PlacedNote",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.EmailMarketerNA": function() {
      var _event = {
        target: {
          id: "EmailMarketerNA",
          value: this.current_seminar.Tracker.EmailMarketerNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.EmailMarketerNA) {
        this.current_seminar.Tracker.DateEmailMarketer = null;
        var _event2 = {
          target: {
            id: "EmailMarketer",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.AddedToPPTNA": function() {
      var _event = {
        target: {
          id: "AddedToPPTNA",
          value: this.current_seminar.Tracker.AddedToPPTNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.AddedToPPTNA) {
        this.current_seminar.Tracker.DateAddedToPPT = null;
        var _event2 = {
          target: {
            id: "AddedToPPT",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.AddedToMapNA": function() {
      var _event = {
        target: {
          id: "AddedToMapNA",
          value: this.current_seminar.Tracker.AddedToMapNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.AddedToMapNA) {
        this.current_seminar.Tracker.DateAddedToMap = null;
        var _event2 = {
          target: {
            id: "AddedToMap",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.PlacedOrderProducerNA": function() {
      var _event = {
        target: {
          id: "PlacedOrderProducerNA",
          value: this.current_seminar.Tracker.PlacedOrderProducerNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.PlacedOrderProducerNA) {
        this.current_seminar.Tracker.DatePlacedOrderProducer = null;
        var _event2 = {
          target: {
            id: "PlacedOrderProducer",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.AddedToTSNA": function() {
      var _event = {
        target: {
          id: "AddedToTSNA",
          value: this.current_seminar.Tracker.AddedToTSNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.AddedToTSNA) {
        this.current_seminar.Tracker.DateAddedToTS = null;
        var _event2 = {
          target: {
            id: "AddedToTS",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.NewProducerPercNA": function() {
      var _event = {
        target: {
          id: "NewProducerPercNA",
          value: this.current_seminar.Tracker.NewProducerPercNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.NewProducerPercNA) {
        this.current_seminar.Tracker.DateNewProducerPerc = null;
        var _event2 = {
          target: {
            id: "NewProducerPerc",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.MailLandedNA": function() {
      var _event = {
        target: {
          id: "MailLandedNA",
          value: this.current_seminar.Tracker.MailLandedNA
        }
      };
      this.saveField(_event);
      if (!this.current_seminar.Tracker.MailLandedNA) {
        this.current_seminar.Tracker.DateMailLanded = null;
        var _event2 = {
          target: {
            id: "MailLanded",
            value: "null"
          }
        };
        this.saveField(_event2);
      }
    },
    "current_seminar.Tracker.TrackingNotes": function() {
      //   var _event = {
      //     target: {
      //       id: "TrackingNotes",
      //       value: this.current_seminar.Tracker.TrackingNotes
      //     }
      //   };
      //   this.saveField(_event);
    }
  }
};
</script>

<style lang="scss" scoped></style>
